import { selector, useRecoilValue } from 'recoil';
import { DisputeService } from 'services';
import { isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { MarDisputeType } from 'types';

export const marDisputeTypes = selector<MarDisputeType[]>({
    key: 'marDisputeTypes',
    get: async ({ get }) => {
        get(refreshState('marDisputeTypes'));
        if (get(isAuthenticated)) {
            const service = new DisputeService();
            return await service.getMarDisputeTypes();
        }
        return [];
    }
});

export const useMarDisputeTypes = () => useRecoilValue(marDisputeTypes);
export const useRefreshMarDisputeTypes = () => useSetRefreshState(marDisputeTypes);